import { useEffect, useState } from 'react';

export default function TopContactBar() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY < 80);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

    return (
      <div
        id="top-contact-bar"
        className={`w-full bg-[#f7fbff] text-sm text-slate-700 transition-[max-height,opacity] duration-300 ease-out ${
          show ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0 overflow-hidden'
        }`}
      >
      <div className="top-contact mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-6 gap-y-1 px-6 py-2 text-center md:h-10 md:flex-nowrap md:justify-between md:py-0 md:text-left">
        <span>123 Main St, Tampa, FL 336XX</span>
        <span>
          (813) 555-0123 ·{' '}
          <a href="mailto:hello@carteram.com" className="underline">
            hello@carteram.com
          </a>
        </span>
      </div>
    </div>
  );
}
